import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Profile } from '@models/profile/profile';
import { getAge } from '@wizbii/angular-utilities';

@Component({
  selector: 'profile-personal-identity',
  templateUrl: './personal-identity.component.html',
  styleUrls: ['./personal-identity.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PersonalIdentityComponent implements OnChanges {
  @Input() profile: Profile;
  @Input() loading: boolean;
  age: number;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.profile && changes.profile.currentValue && changes.profile.currentValue.dateBirthday) {
      this.age = getAge(changes.profile.currentValue.dateBirthday);
    }
  }
}
